//inspiration : https://geeksui.codescandy.com/geeks/pages/landings/landing-courses.html

import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import intern2 from '../image/intern2.jpg';
import intern3 from '../image/intern3.jpg';
import intern4 from '../image/intern4.jpg';
import intern5 from '../image/intern5.jpg';
import intern7 from '../image/intern7.jpg';


// Custom Arrow Components
function NextArrow(props) {
  const { className, style, onClick } = props;
  return (
    <button
      className={className}
      style={{
        ...style,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: '#fff',
        border: 'none',
        borderRadius: '50%',
        boxShadow: '0 2px 8px #eee',
        width: 44,
        height: 44,
        right: -48,
        top: '50%',
        transform: 'translateY(-50%)',
        zIndex: 10,
        fontSize: 22,
        color: '#7b7fd1',
        cursor: 'pointer',
        opacity: 1,
        position: 'absolute',
      }}
      onClick={onClick}
      aria-label="Next"
    >
      &#8594;
    </button>
  );
}

function PrevArrow(props) {
  const { className, style, onClick } = props;
  return (
    <button
      className={className}
      style={{
        ...style,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: '#fff',
        border: 'none',
        borderRadius: '50%',
        boxShadow: '0 2px 8px #eee',
        width: 44,
        height: 44,
        left: -48,
        top: '50%',
        transform: 'translateY(-50%)',
        zIndex: 10,
        fontSize: 22,
        color: '#7b7fd1',
        cursor: 'pointer',
        opacity: 1,
        position: 'absolute',
      }}
      onClick={onClick}
      aria-label="Previous"
    >
      &#8592;
    </button>
  );
}

// Static metadata; text comes from i18n
const courseData = [
  {
    title: "IT Support",
    descKey: "course1Desc",
    category: "IT",
    scheduleKey: "scheduleMonFri",
    bgImage: "https://images.unsplash.com/photo-1515378791036-0648a3ef77b2?auto=format&fit=crop&w=900&q=80",
  },
  {
    title: "Data Engineering",
    descKey: "course2Desc",
    category: "IT",
    scheduleKey: "scheduleMonFri",
    bgImage: "https://cdn.prod.website-files.com/64fef88ee8b22d3d21b715a2/65853d9764548e4eeac17557_All%20You%20Need%20to%20Know%20about%20Data%20Engineering.webp",
  },
  {
    title: "Software Developer",
    descKey: "course3Desc",
    category: "IT",
    scheduleKey: "scheduleMonFri",
    bgImage: "https://images.unsplash.com/photo-1461749280684-dccba630e2f6?auto=format&fit=crop&w=900&q=80",
  },
  {
    title: "Accountant",
    descKey: "course4Desc",
    category: "Accounting",
    scheduleKey: "scheduleMonSat",
    bgImage: "https://tgg-accounting.com/wp-content/uploads/2023/07/accounting-asset-based-2-scaled.jpeg",
  },
];

const categoryKeys = ["All", "IT", "Accounting"];

function Career() {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState(0);
  const navigate = useNavigate();

  const categoryLabels = [
    t('career.filterAll'),
    t('career.filterIT'),
    t('career.filterAccounting'),
  ];

  const filteredCourses =
    activeTab === 0
      ? courseData
      : courseData.filter((c) => c.category === categoryKeys[activeTab]);

  const sliderSettings = {
    dots: true,
    infinite: filteredCourses.length > 1,
    speed: 500,
    slidesToShow: Math.min(4, filteredCourses.length),
    slidesToScroll: 1,
    arrows: true,
    autoplay: activeTab === 0 && filteredCourses.length > 1,
    autoplaySpeed: 2500,
    pauseOnHover: true,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    centerMode: filteredCourses.length < 4,
    centerPadding: filteredCourses.length === 1 ? "0px" : filteredCourses.length === 2 ? "200px" : "60px",
    responsive: [
      { breakpoint: 1200, settings: { slidesToShow: 3 } },
      { breakpoint: 900, settings: { slidesToShow: 2 } },
      { breakpoint: 600, settings: { slidesToShow: 1 } },
    ],
  };

  const [isDragging, setIsDragging] = useState(false);
  const [dragStartX, setDragStartX] = useState(null);

  const handleMouseDown = (e) => {
    setIsDragging(false);
    setDragStartX(e.clientX);
  };
  const handleMouseMove = (e) => {
    if (dragStartX !== null && Math.abs(e.clientX - dragStartX) > 10) {
      setIsDragging(true);
    }
  };
  const handleMouseUp = () => {
    setDragStartX(null);
  };

  const renderCourseCard = (course, idx) => (
    <div
      key={idx}
      style={{
        background: '#fff',
        borderRadius: 16,
        boxShadow: '0 2px 16px #f0f0f7',
        width: 260,
        minHeight: 320,
        margin: '0 auto',
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
        position: 'relative',
        border: '1px solid #f2f2f2',
        cursor: 'pointer',
        transition: 'box-shadow 0.2s',
      }}
      onMouseDown={handleMouseDown}
      onMouseMove={handleMouseMove}
      onMouseUp={handleMouseUp}
      onClick={() => {
        if (!isDragging) {
          navigate(`/careers/${course.title.replace(/\s+/g, '-').toLowerCase()}`);
        }
      }}
      title={`${t('career.viewDetails')} ${course.title}`}
    >
      <div style={{
        height: 120,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundImage: `url(${course.bgImage})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        position: 'relative',
      }}>
        <div style={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          background: 'rgba(0,0,0,0.18)',
          zIndex: 1,
        }} />
      </div>
      <div style={{ padding: 20, flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
        <div>
          <div style={{ fontWeight: 700, fontSize: 18, marginBottom: 8 }}>{course.title}</div>
          <div style={{ fontWeight: 500, fontSize: 15, marginBottom: 12 }}>{t(`career.${course.descKey}`)}</div>
        </div>
        <div style={{ fontSize: 14, color: '#888', marginBottom: 8 }}>
          <span style={{ marginRight: 10 }}>⏱ {t(`career.${course.scheduleKey}`)}</span>
          <span>• {t('career.internLevel')}</span>
        </div>
      </div>
    </div>
  );

  return (
    <>
      {/* Why Intern With Us Section + Animated Background */}
      <div style={{
        background: 'linear-gradient(180deg, #fafbff 0%, #f8f9ff 100%)',
        padding: '250px 0 250px 0',
        fontFamily: 'Prompt, sans-serif',
        position: 'relative',
        overflow: 'hidden',
      }}>
        <svg style={{position:'absolute',top:0,left:0,width:'100%',height:'100%',zIndex:0,pointerEvents:'none'}} width="100%" height="100%" viewBox="0 0 1440 600" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="200" cy="120" r="90" fill="#e0e7ff" style={{opacity:0.6}}>
            <animate attributeName="cy" values="120;160;120" dur="6s" repeatCount="indefinite"/>
          </circle>
          <circle cx="1200" cy="180" r="60" fill="#c7d2fe" style={{opacity:0.5}}>
            <animate attributeName="cy" values="180;220;180" dur="7s" repeatCount="indefinite"/>
          </circle>
          <circle cx="400" cy="400" r="50" fill="#dbeafe" style={{opacity:0.4}}>
            <animate attributeName="cx" values="400;440;400" dur="5s" repeatCount="indefinite"/>
          </circle>
          <circle cx="1100" cy="500" r="80" fill="#f3e8ff" style={{opacity:0.3}}>
            <animate attributeName="cy" values="500;540;500" dur="9s" repeatCount="indefinite"/>
          </circle>
        </svg>
        <div style={{
          maxWidth: 1200,
          margin: '0 auto',
          padding: '0 20px',
          textAlign: 'center',
          position: 'relative',
          zIndex: 1,
        }}>
          <div style={{
            color: '#7b7fd1',
            fontWeight: 600,
            letterSpacing: 2,
            fontSize: 16,
            marginBottom: 10,
            textTransform: 'uppercase'
          }}>
            {t('career.topEyebrow')}
          </div>
          <h1 style={{
            fontSize: 40,
            fontWeight: 700,
            margin: '0 0 18px 0'
          }}>
            {t('career.topHeading')}
          </h1>
          <div style={{
            fontSize: 20,
            color: '#555',
            marginBottom: 48
          }}>
            {t('career.topDescription')}
          </div>
          <div style={{
            display: 'flex',
            justifyContent: 'center',
            gap: 60,
            flexWrap: 'wrap'
          }}>
            {[
              { icon: '⚙️', titleKey: 'benefit1Title', descKey: 'benefit1Desc' },
              { icon: '👨‍💻', titleKey: 'benefit2Title', descKey: 'benefit2Desc' },
              { icon: '🎓', titleKey: 'benefit3Title', descKey: 'benefit3Desc' },
              { icon: '🤝', titleKey: 'benefit4Title', descKey: 'benefit4Desc' },
            ].map((benefit, idx) => (
              <div key={idx} style={{
                maxWidth: 220,
                background: '#ffffff',
                borderRadius: 12,
                padding: 24,
                boxShadow: '0 4px 16px rgba(0, 0, 0, 0.05)',
                border: '1px solid rgba(123, 127, 209, 0.08)',
                transition: 'transform 0.3s ease, box-shadow 0.3s ease',
              }}>
                <div style={{ fontSize: 38, color: '#7b7fd1', marginBottom: 18 }}>
                  <span role="img" aria-label="benefit">{benefit.icon}</span>
                </div>
                <div style={{ fontWeight: 700, fontSize: 18, marginBottom: 8 }}>
                  {t(`career.${benefit.titleKey}`)}
                </div>
                <div style={{ color: '#555', fontSize: 15 }}>
                  {t(`career.${benefit.descKey}`)}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div style={{ background: '#ffffffff', minHeight: '100vh', paddingBottom: 60, paddingTop: 60, fontFamily: 'Prompt, sans-serif' }}>
        <div style={{ maxWidth: 1200, margin: '0 auto', padding: '60px 20px 0 20px' }}>
          <div style={{ color: '#7b7fd1', fontWeight: 600, letterSpacing: 2, fontSize: 16, marginBottom: 10 }}>
            {t('career.mainEyebrow')}
          </div>
          <h1 style={{ fontSize: 44, fontWeight: 700, margin: 0 }}>{t('career.mainHeading')}</h1>
          <div style={{ fontSize: 20, color: '#555', margin: '18px 0 36px 0' }}>
            {t('career.mainDescription')}
          </div>

          {/* Tabs */}
          <div style={{ display: 'flex', gap: 32, borderBottom: '2px solid #eee', marginBottom: 36 }}>
            {categoryLabels.map((label, idx) => (
              <div
                key={idx}
                onClick={() => { setActiveTab(idx); }}
                style={{
                  paddingBottom: 10,
                  cursor: 'pointer',
                  borderBottom: activeTab === idx ? '3px solid #7b7fd1' : '3px solid transparent',
                  color: activeTab === idx ? '#7b7fd1' : '#888',
                  fontWeight: 500,
                  fontSize: 18,
                  transition: 'color 0.2s',
                }}
              >
                {label}
              </div>
            ))}
          </div>

          {/* Card List or Carousel */}
          <div style={{ maxWidth: 1200, margin: '0 auto', marginBottom: 40 }}>
            {filteredCourses.length < 4 ? (
              <div style={{ display: 'flex', justifyContent: filteredCourses.length === 1 ? 'center' : 'flex-start', gap: 32 }}>
                {filteredCourses.map((course, idx) => renderCourseCard(course, idx))}
              </div>
            ) : (
              <Slider {...sliderSettings}>
                {filteredCourses.map((course, idx) => (
                  <div key={idx}>{renderCourseCard(course, idx)}</div>
                ))}
              </Slider>
            )}
          </div>

          {/* Section: บรรยากาศการทำงาน */}
          <div style={{ marginTop: 120 }}>
            <div style={{ color: '#7b7fd1', fontWeight: 600, letterSpacing: 2, fontSize: 16, marginBottom: 10 }}>
              {t('career.galleryEyebrow')}
            </div>
            <div style={{ fontSize: 24, fontWeight: 700, marginBottom: 24 }}>
              {t('career.galleryHeading')}
            </div>
            <div className="gallery" style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: 20 }}>
              <figure className="gallery__item gallery__item--1 mb-0">
                <img src={intern2} alt="Gallery 1" className="gallery__img rounded-3" style={{ width: '100%', borderRadius: 12 }} />
              </figure>
              <figure className="gallery__item gallery__item--3 mb-0">
                <img src={intern3} alt="Gallery 3" className="gallery__img rounded-3" style={{ width: '100%', borderRadius: 12 }} />
              </figure>
            </div>

            <div className="gallery" style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 20, marginTop: 20 }}>
              <figure className="gallery__item gallery__item--1 mb-0">
                <img src={intern4} alt="Gallery 4" className="gallery__img rounded-3" style={{ width: '100%', borderRadius: 12 }} />
              </figure>
              <figure className="gallery__item gallery__item--3 mb-0">
                <img src={intern5} alt="Gallery 5" className="gallery__img rounded-3" style={{ width: '100%', borderRadius: 12 }} />
              </figure>
              <figure className="gallery__item gallery__item--3 mb-0">
                <img src={intern7} alt="Gallery 7" className="gallery__img rounded-3" style={{ width: '100%', borderRadius: 12 }} />
              </figure>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Career;
